import type { DropCardVariant } from '../../constants/dropCardVariants';
import { getDropAbArm } from '../getDropAbArm/getDropAbArm';

// The variant a tested grid shows the visitor, as app.css picks it: the
// variant forced with `?heni_ab=<variant>` (outside production) when the grid
// offers it, else the visitor's arm.
export const getDropAbVariant = (
	variants: DropCardVariant[]
): DropCardVariant => {
	const forced =
		typeof document === 'undefined'
			? null
			: document.documentElement.getAttribute('data-ab-variant');

	return (
		variants.find((variant) => variant === forced) ??
		variants[getDropAbArm(variants.length)]
	);
};
